__turbopack_context__.v({
  "card": "WarehouseSearch-module-scss-module__PrYCQa__card",
  "cardTitle": "WarehouseSearch-module-scss-module__PrYCQa__cardTitle",
  "container": "WarehouseSearch-module-scss-module__PrYCQa__container",
  "fishIconItem": "WarehouseSearch-module-scss-module__PrYCQa__fishIconItem",
  "fishIconsList": "WarehouseSearch-module-scss-module__PrYCQa__fishIconsList",
  "formControl": "WarehouseSearch-module-scss-module__PrYCQa__formControl",
  "formGrid": "WarehouseSearch-module-scss-module__PrYCQa__formGrid",
  "main": "WarehouseSearch-module-scss-module__PrYCQa__main",
  "picture": "WarehouseSearch-module-scss-module__PrYCQa__picture",
  "section": "WarehouseSearch-module-scss-module__PrYCQa__section",
  "seeOnMapButton": "WarehouseSearch-module-scss-module__PrYCQa__seeOnMapButton",
  "submitButton": "WarehouseSearch-module-scss-module__PrYCQa__submitButton",
  "title": "WarehouseSearch-module-scss-module__PrYCQa__title",
  "titleBlock": "WarehouseSearch-module-scss-module__PrYCQa__titleBlock",
});
